// src/types/index.ts
function resolveStoryVisibilityTier(story) {
  if (story.published) return "worldwide";
  if (story.soft_published) return "limited";
  return "private";
}
function isStoryJettisoned(story) {
  return story.jettisoned_at != null;
}
function isSystemStory(story) {
  return !!story.is_system;
}
function jettisonDaysRemaining(story) {
  if (!story.jettisoned_at) return 0;
  const jettDate = new Date(story.jettisoned_at).getTime();
  const expiresAt = jettDate + 7 * 24 * 60 * 60 * 1e3;
  const remaining = expiresAt - Date.now();
  return Math.max(0, Math.ceil(remaining / (24 * 60 * 60 * 1e3)));
}
function computeSceneVisibility(sceneList, opts) {
  if (opts.isCreator || opts.endingSeen) {
    return sceneList.map(() => ({ navigable: true, dimmed: false }));
  }
  return sceneList.map((scene) => ({
    navigable: scene.is_title,
    dimmed: !scene.is_title
  }));
}

export { computeSceneVisibility, isStoryJettisoned, isSystemStory, jettisonDaysRemaining, resolveStoryVisibilityTier };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map